function appendGtmScript(gtmId: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);
}

export function applyNormalGtm() {
    appendGtmScript('GTM-MMVWSV3');
}

export function applyEuroGtm() {
    appendGtmScript('GTM-MXK4KQK');
}

export function setPlatformDimension(platform: 'web' | 'app') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        platform,
    });
}

export function sendEventToGA(event: string, eventLabel: string) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        eventLabel,
    });

    // clear event label
    window.dataLayer.push({
        eventLabel: '',
    });
}
